import { createAction, props } from '@ngrx/store';

import type { FileItem as NdtFile } from '@app/types/file-item.type';

export const UPLOAD_FILES = '[Upload] Upload Files';
export const UPLOAD_FILE_STARTED = '[Upload] Upload File Started';
export const UPLOAD_FILE_PROGRESS = '[Upload] Upload File Progress';
export const UPLOAD_FILE_SUCCESS = '[Upload] Upload File Success';
export const UPLOAD_FILE_FAIL = '[Upload] Upload File Fail';
export const UPLOAD_FILES_FAIL = '[Upload] Upload Files Fail';
export const UPLOAD_FILE_COMPLETE = '[Upload] Upload File Complete';
export const UPLOAD_FILES_ALL_COMPLETE = '[Upload] Upload Files All Complete';
export const CLEAR_FILE = '[Upload] Clear File';
export const CLEAR_FILE_SUCCESS = '[Upload] Clear File Success';
export const CLEAR_FILE_FAIL = '[Upload] Clear File Fail';

export const CLEAR_ALERT = '[Upload] Clear Alert';

export const RESET_UPLOAD = '[Upload] Reset Upload';

export const uploadFiles: any = createAction(
  UPLOAD_FILES,
  props<{ files: File[]; paths?: string[] }>(),
);

export const uploadFileStarted: any = createAction(
  UPLOAD_FILE_STARTED,
  props<{ name: string; uploadId: string }>(),
);

export const uploadFileProgress: any = createAction(
  UPLOAD_FILE_PROGRESS,
  props<{
    name: string;
    progress: number;
    uploadId: string;
    uploaded: number;
    size: number;
    speed: number;
    remaining: number;
  }>(),
);

export const uploadFileSuccess: any = createAction(
  UPLOAD_FILE_SUCCESS,
  props<{ file: NdtFile; parentId?: string }>(),
);

export const uploadFileComplete: any = createAction(
  UPLOAD_FILE_COMPLETE,
  props<{ name: string; fileId: string; chunkCount: number; parentId?: string }>(),
);

export const uploadFilesAllComplete: any = createAction(UPLOAD_FILES_ALL_COMPLETE);

export const uploadFileFail: any = createAction(
  UPLOAD_FILE_FAIL,
  props<{ name: string; error: string; params: Record<string, string> }>(),
);

export const uploadFilesFail: any = createAction(UPLOAD_FILES_FAIL, props<{ error: string }>());

export const clearFile: any = createAction(
  CLEAR_FILE,
  props<{ fileId: string; error?: string; params?: Record<string, string> }>(),
);

export const clearFileSuccess: any = createAction(CLEAR_FILE_SUCCESS, props<{ name: string }>());

export const clearFileFail: any = createAction(
  CLEAR_FILE_FAIL,
  props<{ error: string; name: string }>(),
);

export const clearAlert: any = createAction(CLEAR_ALERT);

export const resetUpload: any = createAction(RESET_UPLOAD);
